<template>
  <!-- CTA -->
  <section id="cta">
    <header>
    <h2>Enjoyed the website?</h2>
    <p>Participate to development ! <strong>Free access today</strong></p>
    </header>
    <footer>
    <ul class="buttons">
      <li><a href="https://gitlab.d2-si.eu/npellegrin/aws-url-shortener" class="button primary">View source</a></li>
      <li><a href="mailto:nicolas.pellegrin@d2si.io" class="button">Ask developers</a></li>
    </ul>
    </footer>
  </section>
</template>

<script>
export default {
  name: 'Social'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Social.vue